import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSmallArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.25537 9.51191L9.4137 11.6702C9.7387 11.9952 10.2637 11.9952 10.5887 11.6702L12.747 9.51191C13.272 8.98691 12.897 8.08691 12.1554 8.08691H7.8387C7.09703 8.08691 6.73037 8.98691 7.25537 9.51191Z",
		fill: "currentColor"
	})
});
export default SvgSmallArrow;
